export const TitleConfigQueryKeys = {
  all: () => ["titleConfig"],
  categories: (searchTerm: string, configured?: boolean) => [
    ...TitleConfigQueryKeys.all(),
    "categories",
    configured === undefined ? "any" : String(configured),
    searchTerm,
  ],
  single: (partCategoryId: string | undefined) => [
    ...TitleConfigQueryKeys.all(),
    partCategoryId,
  ],
  ebayAspects: (partCategoryId: string | undefined) => [
    ...TitleConfigQueryKeys.all(),
    partCategoryId,
    "ebayAspects",
  ],
};
